import { GUI } from 'dat.gui';
import { camera } from './scene';
import { isDebugging } from './urlParams';

if (isDebugging) {
  const gui = new GUI({ width: 600 });

  const cameraPositionControls = gui.addFolder('Camera Position Controls');

  cameraPositionControls
    .add(camera.position, 'x', 0, 2000, 1)
    .listen();

  cameraPositionControls
    .add(camera.position, 'y', 0, 1000, 1)
    .listen();

  cameraPositionControls
    .add(camera.position, 'z', -2000, 2000, 1)
    .listen();

  cameraPositionControls.open();

  const cameraTargetControls = gui.addFolder('Camera Target Controls');
  cameraTargetControls
    .add(camera.target, 'x', 0, 1000, 1)
    .listen();

  cameraTargetControls
    .add(camera.target, 'y', -500, 500, 1)
    .listen();

  cameraTargetControls
    .add(camera.target, 'z', -4000, 0, 1)
    .listen();

  cameraTargetControls.open();
}
